import { useTranslation } from "react-i18next";
import styles from "./styles.module.css";
import { FaCheckCircle } from "react-icons/fa";
import { Element } from "react-scroll";
import { isRTL } from 'src/utils/global';

const WhyChooseUs = () => {
  const { t } = useTranslation("home");

  // تحديث المفاتيح هنا لتتطابق مع ملف الـ JSON الجديد
  const reasons = [
    t("why_us.items.quality_guaranteed"),
    t("why_us.items.competitive_prices"),
    t("why_us.items.chinese_expertise"),
    t("why_us.items.fast_delivery"),
    t("why_us.items.technical_support"),
  ];

  return (
    <Element name="whyUs" className={`${styles.whyUs} ${isRTL() && styles.rtl}`}>
      <div className="container">
        {/* Title */}
        <h2 className={styles.title}>
          {t("why_us.title", "لماذا تختار الدرب الأول؟")}
        </h2>

        {/* List */}
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <ul className={styles.list}
              data-aos="fade-up"
              data-aos-anchor-placement="top-bottom"
              data-aos-delay="100"
            >

              {reasons.map((item, index) => (
                <li key={index}

                  className={styles.listItem}>
                  <FaCheckCircle className={styles.icon} />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </Element>
  );
};

export default WhyChooseUs;